import { getPriceFilterLabel } from "~/components/products-layout/components/products-filters/components/filter/helpers";
import { getCurrencyCodeByLocale, LOCALES } from "~/constants/i18n";
import {
  getFilterValuesForRequest,
  ProductFilterQuery,
} from "~/helpers/get-filter-values-for-request";

export const getFilterTypeAndValueGA = (
  appliedFilters: [string, number | boolean] | undefined,
  locale: LOCALES,
) => {
  let appliedFilterForGA = <ProductFilterQuery[]>[];
  if (appliedFilters?.[0] && appliedFilters?.[1]) {
    appliedFilterForGA = getFilterValuesForRequest({
      [appliedFilters?.[0]]: appliedFilters?.[1],
    });
  }

  const currency = getCurrencyCodeByLocale(locale);

  const checkboxValue = JSON.stringify({
    start: appliedFilterForGA[0]?.value?.[0] ?? 0,
    end: Number(appliedFilterForGA[0]?.value?.[1]),
  });

  const priceLabel = getPriceFilterLabel(checkboxValue, locale, currency, "Over");

  const value =
    appliedFilterForGA[0]?.key === "sku_price"
      ? priceLabel
      : appliedFilterForGA[0]?.value?.[0];

  return {
    filterType: appliedFilterForGA[0]?.key,
    filterValue: value,
  };
};
